import { Controller } from "stimulus"
import $ from "jquery"

export default class extends Controller {
  static targets = ["modalitySelect", "formVersionSelect"]
  static values = { modalityForms: Object }

  connect() {
    this.boundModalityChange = () => this.modalityChanged()
    if (this.hasModalitySelectTarget) {
      $(this.modalitySelectTarget).on("change", this.boundModalityChange)
    }
  }

  disconnect() {
    if (this.hasModalitySelectTarget) {
      $(this.modalitySelectTarget).off("change", this.boundModalityChange)
    }
  }

  modalityChanged() {
    if (!this.hasFormVersionSelectTarget) return

    const modalityId = this.modalitySelectTarget.value
    const select = this.formVersionSelectTarget
    const config = this.modalityFormsValue[modalityId]

    select.innerHTML = ""
    const blank = document.createElement("option")
    blank.value = ""
    blank.textContent = "Use modality default"
    select.appendChild(blank)

    if (!config || !config.options) {
      this.setSelectValue(select, "")
      this.refreshSelect2(select)
      return
    }

    config.options.forEach((opt) => {
      const option = document.createElement("option")
      option.value = opt.id
      option.textContent = opt.label
      select.appendChild(option)
    })

    const primary = config.primaryId ? String(config.primaryId) : ""
    this.setSelectValue(select, primary)
    this.refreshSelect2(select)
  }

  setSelectValue(select, value) {
    select.value = value
  }

  refreshSelect2(select) {
    const $select = $(select)
    if ($select.hasClass("select2-hidden-accessible")) {
      $select.trigger("change.select2")
    }
    this.element.dispatchEvent(new CustomEvent("prescreen:refresh-selects", { bubbles: true }))
  }
}
